import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import Title from './Title';
import { LoadingImage } from './resultsStyles';


export const StyledResultTitle = css`
  margin-bottom: 0px;

  ${({ retirement }) => retirement && css`
    align-self: center;
    margin-bottom: 10px;
  `}
`;

const Loading = ({ title }) => (
  <Fragment>
    <Title level={2} styles={StyledResultTitle}>
      {title}
      <span role="img" aria-label="secure">⚓️</span>
    </Title>
    <LoadingImage src="https://s3.us-east-2.amazonaws.com/finauta/art/load.gif" alt="loading..." />
  </Fragment>

);

Loading.propTypes = {
  title: PropTypes.string,
};

Loading.defaultProps = {
  title: '',
};

export default Loading;
